import React, { useState } from "react";

import { Button, useNotify } from "react-admin";

import { EmailIcon } from "../../../components/common/iconography";
import { logError } from "../../../utils/appUtils";
import {
  notifyPrimaryInviteResult,
  sendPrimaryDispatchInvite,
} from "./primaryDispatchInvite";

/**
 * Invite (or re-invite) the carrier's email address as its primary dispatch
 * user, from the carrier's own edit page.
 *
 * This is the follow-up path for the carriers that predate automatic invites
 * and for kiosk-created ones, which arrive with no address until a manager
 * adds one here. Idempotent: an address that is already a member gets a
 * notice, not a duplicate.
 */
export const SendPrimaryInviteButton = ({ record }) => {
  const notify = useNotify();
  const [busy, setBusy] = useState(false);

  if (!record?.email) return null;

  const handleClick = async () => {
    setBusy(true);
    try {
      const result = await sendPrimaryDispatchInvite(record);
      notifyPrimaryInviteResult(notify, record, result);
    } catch (error) {
      logError(
        "managerApp:carriers:SendPrimaryInviteButton:handleClick",
        error,
        notify,
      );
    } finally {
      setBusy(false);
    }
  };

  return (
    <Button label="Send Invite" disabled={busy} onClick={handleClick}>
      <EmailIcon />
    </Button>
  );
};
